// ZB Featured Products — carousel arrows, progress bar, image dots, quick view modal

(function () {
  // ---------- Money formatting (Shopify-style) ----------
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';

    switch (key) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  // ---------- Carousel arrows + progress bar ----------
  function initCarousel(root) {
    var row = root.querySelector('.zb-fp__row');
    var prevBtn = root.querySelector('.zb-fp__arrow--prev');
    var nextBtn = root.querySelector('.zb-fp__arrow--next');
    var progressFill = root.querySelector('.zb-fp__progress-fill');

    if (!row) return;

    function cardWidth() {
      var card = row.querySelector('.zb-fp__card');
      return card ? card.getBoundingClientRect().width + 16 : row.clientWidth;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        row.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        row.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });
    }

    if (progressFill) {
      var updateProgress = function () {
        var maxScroll = row.scrollWidth - row.clientWidth;
        if (maxScroll <= 0) {
          progressFill.style.width = '100%';
          return;
        }
        var pct = (row.scrollLeft / maxScroll) * 100;
        progressFill.style.width = Math.max(10, pct) + '%';
      };
      row.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    if (prevBtn || nextBtn) {
      var toggleArrows = function () {
        var maxScroll = row.scrollWidth - row.clientWidth;
        if (prevBtn) prevBtn.style.opacity = row.scrollLeft <= 4 ? '0.4' : '1';
        if (nextBtn) nextBtn.style.opacity = row.scrollLeft >= maxScroll - 4 ? '0.4' : '1';
      };
      row.addEventListener('scroll', toggleArrows, { passive: true });
      toggleArrows();
    }
  }

  // ---------- Image dots + hover auto-cycle ----------
  function initCardImages(root) {
    root.querySelectorAll('.zb-fp__image-wrap').forEach(function (wrap) {
      var images = wrap.querySelectorAll('.zb-fp__image');
      var dots = wrap.querySelectorAll('.zb-fp__dot');
      if (images.length < 2) return;

      var cycleTimer = null;

      function setActive(index) {
        images.forEach(function (img) {
          img.classList.toggle('active', img.getAttribute('data-image-index') === String(index));
        });
        dots.forEach(function (dot) {
          dot.classList.toggle('active', dot.getAttribute('data-image-index') === String(index));
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setActive(dot.getAttribute('data-image-index'));
        });
      });

      wrap.addEventListener('mouseenter', function () {
        var current = 0;
        cycleTimer = setInterval(function () {
          current = (current + 1) % images.length;
          setActive(current);
        }, 1400);
      });

      wrap.addEventListener('mouseleave', function () {
        clearInterval(cycleTimer);
        setActive(0);
      });
    });
  }

  // ---------- Quick view modal ----------
  function initQuickView(root) {
    var modal = root.querySelector('.zb-fp__quickview-modal');
    if (!modal) return;

    var moneyFormat = modal.getAttribute('data-money-format') || '${{amount}}';
    var body = modal.querySelector('.zb-fp__quickview-body');

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    modal.querySelectorAll('[data-qv-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });

    function renderProduct(product) {
      var variant = product.variants[0];
      var images = product.images && product.images.length ? product.images : [product.featured_image];

      var thumbsHtml = images
        .slice(0, 6)
        .map(function (img, i) {
          return '<img class="zb-fp__qv-thumb' + (i === 0 ? ' active' : '') + '" data-src="' + img + '" src="' + img + '" alt="">';
        })
        .join('');

      var optionsHtml = product.options
        .map(function (optionName, i) {
          var values = [];
          product.variants.forEach(function (v) {
            var val = v['option' + (i + 1)];
            if (values.indexOf(val) === -1) values.push(val);
          });
          var optionsMarkup = values
            .map(function (val) {
              return '<option value="' + val + '">' + val + '</option>';
            })
            .join('');
          return (
            '<div class="zb-fp__qv-option" data-option-index="' +
            i +
            '"><label>' +
            optionName +
            '</label><select>' +
            optionsMarkup +
            '</select></div>'
          );
        })
        .join('');

      body.innerHTML =
        '<div class="zb-fp__qv-layout">' +
        '<div class="zb-fp__qv-gallery">' +
        '<img class="zb-fp__qv-main-image" src="' + images[0] + '" alt="' + product.title + '">' +
        (images.length > 1 ? '<div class="zb-fp__qv-thumbs">' + thumbsHtml + '</div>' : '') +
        '</div>' +
        '<div class="zb-fp__qv-details">' +
        '<h2 class="zb-fp__qv-title">' + product.title + '</h2>' +
        '<div class="zb-fp__qv-price">' + formatMoney(variant.price, moneyFormat) + '</div>' +
        '<form class="zb-fp__qv-form">' +
        optionsHtml +
        '<div class="zb-fp__qv-qty-row"><label>Qty</label><input type="number" min="1" value="1" class="zb-fp__qv-qty"></div>' +
        '<button type="submit" class="zb-fp__qv-add"' + (variant.available ? '' : ' disabled') + '>' +
        (variant.available ? 'Add to cart' : 'Sold out') +
        '</button>' +
        '<div class="zb-fp__qv-status"></div>' +
        '</form>' +
        '<a class="zb-fp__qv-link" href="' + product.url + '">View full details</a>' +
        '</div>' +
        '</div>';

      var mainImg = body.querySelector('.zb-fp__qv-main-image');
      body.querySelectorAll('.zb-fp__qv-thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          mainImg.src = thumb.getAttribute('data-src');
          body.querySelectorAll('.zb-fp__qv-thumb').forEach(function (t) {
            t.classList.remove('active');
          });
          thumb.classList.add('active');
        });
      });

      var selects = Array.prototype.slice.call(body.querySelectorAll('.zb-fp__qv-option select'));
      var addBtn = body.querySelector('.zb-fp__qv-add');
      var statusEl = body.querySelector('.zb-fp__qv-status');

      function currentVariant() {
        var selectedOptions = selects.map(function (s) {
          return s.value;
        });
        var found = null;
        product.variants.forEach(function (v) {
          var matches = true;
          for (var i = 0; i < selectedOptions.length; i++) {
            if (v['option' + (i + 1)] !== selectedOptions[i]) {
              matches = false;
              break;
            }
          }
          if (matches) found = v;
        });
        return found;
      }

      function updateForVariant() {
        var v = currentVariant();
        if (!v) return;
        body.querySelector('.zb-fp__qv-price').textContent = formatMoney(v.price, moneyFormat);
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }

      selects.forEach(function (select) {
        select.addEventListener('change', updateForVariant);
      });

      var form = body.querySelector('.zb-fp__qv-form');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = currentVariant();
        if (!v || !v.available) return;
        var qty = parseInt(body.querySelector('.zb-fp__qv-qty').value, 10) || 1;

        addBtn.disabled = true;
        statusEl.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            statusEl.textContent = 'Added to cart!';
            addBtn.disabled = false;
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(function () {
            statusEl.textContent = 'Something went wrong. Please try again.';
            addBtn.disabled = false;
          });
      });
    }

    root.querySelectorAll('.zb-fp__quickview').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var url = btn.getAttribute('data-product-url');
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        body.innerHTML = '<div class="zb-fp__quickview-loading">Loading...</div>';

        fetch(url + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to load product');
            return res.json();
          })
          .then(renderProduct)
          .catch(function () {
            body.innerHTML =
              '<div class="zb-fp__quickview-loading">Could not load this product. <a href="' + url + '">View product page</a></div>';
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.zb-fp').forEach(function (root) {
      initCarousel(root);
      initCardImages(root);
      initQuickView(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.zb-fp');
    if (root) {
      initCarousel(root);
      initCardImages(root);
      initQuickView(root);
    }
  });
})();